export default __webpack_public_path__ + "ga4.2f5561f2.png";